import * as React from 'react';
import Slider from 'react-slick';

import { ISimilarProduct } from '../../components/SimilarProducts/SimilarProducts';
import { ClassName } from '../../utils/utils';
import { ProductBox, ProductBoxNews } from '../modules';

const sliderSettings: any = {
  dots: false,
  arrows: true,
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }
  ]
};

interface IProductSliderProps {
  products: ISimilarProduct[];
  type?: string;

  hideFavorite?: boolean;
}

const ProductSlider = (props: IProductSliderProps) => {
  const { type } = props;

  let boxType = 'catalog';
  if (type && type === 'cart') {
    boxType = 'buy';
  }

  return (
    <Slider
      className={
        ClassName('productSlider', [ type ])
      }
      {...sliderSettings}
    >
      {props.products.map((item: any, i) => {
        return (
          <div className="productSlider__item" key={i}>
            {type !== 'news' &&
              <ProductBox
                language={item.language}
                category={item.category}
                sizes={item.sizes}
                variant={item.variant}
                boxType={boxType}
                hideFavorite={props.hideFavorite}
              />}
            {type === 'news' &&
              <ProductBoxNews
                language={item.language}
                product={item.variant.product}
              />}
          </div>
        );
      })}
    </Slider>
  );
};

export default ProductSlider;



// WEBPACK FOOTER //
// ./src/modules/ProductSlider/ProductSlider.tsx